export default __webpack_public_path__ + "static/card-6-65fe0b0220f37b7055a821aa283dd25e.png";